'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.default = _default;
var _reportQuestion = _interopRequireDefault(require('./utils/reportQuestion'));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : { default: e };
}
function _typeof(e) {
    return (_typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (e) {
        return typeof e;
    } : function (e) {
        return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : typeof e;
    })(e);
}
var timestampIndex = 0, date = new Date();
function _default(d) {
    var e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, t = e.data, l = void 0 === t ? {} : t, o = e.jsonp, p = void 0 === o ? 'callback' : o, n = e.jsonpCallback, s = void 0 === n ? 'f_'.concat(date).concat(timestampIndex++) : n, a = e.cache, f = void 0 === a ? ''.concat(new Date().valueOf()).concat(timestampIndex++) : a, r = e.timeout, m = void 0 === r ? 60000 : r;
    return new Promise(function (e, t) {
        var o = setTimeout(function () {
                t(new Error('timeout|请求超时'.concat(m)));
            }, m), n = [];
        if ('object' === _typeof(l)) {
            for (var a = 0, r = Object.keys(l); a < r.length; a++) {
                var c = r[a];
                n.push(''.concat(encodeURIComponent(c), '=').concat(encodeURIComponent(l[c])));
            }
            n.push(''.concat(encodeURIComponent(p), '=').concat(encodeURIComponent(s))), f && n.push('_='.concat(f)), d = d.includes('?') ? ''.concat(d, '&').concat(n.join('&')) : ''.concat(d, '?').concat(n.join('&'));
            var i = document.createElement('script');
            i.src = d, window[s] = function () {
                (0, _reportQuestion.default)(d), e.apply(void 0, arguments);
            }, i.onload = i.onreadystatechange = function () {
                if (!this.readyState || 'loaded' === this.readyState || 'complete' === this.readyState) {
                    clearTimeout(o), i.onload = i.onreadystatechange = null;
                    var e = document.getElementsByTagName('head')[0];
                    e && e.removeChild(i);
                }
            }, i.onerror = function () {
                clearTimeout(o), t(new Error('scriptLoaderror|脚本加载错误'));
            };
            var u = document.getElementsByTagName('head')[0];
            u && u.appendChild(i);
        } else
            t(new Error('typeError|data必须为一个对象'));
    });
}
date = date.valueOf().toString(16);